import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faCalendarDay } from '@fortawesome/pro-regular-svg-icons/faCalendarDay';
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import { faFileInvoice } from '@fortawesome/pro-regular-svg-icons/faFileInvoice';
import { faFolderBlank } from '@fortawesome/pro-regular-svg-icons/faFolderBlank';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faPhoneLaptop } from '@fortawesome/pro-regular-svg-icons/faPhoneLaptop';
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { faShield } from '@fortawesome/pro-regular-svg-icons/faShield';
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { faUserClock } from '@fortawesome/pro-regular-svg-icons/faUserClock';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faVideoSlash } from '@fortawesome/pro-regular-svg-icons/faVideoSlash';

library.add(
  faArrowRight,
  faCalendarAlt,
  faCalendarDay,
  faDownload,
  faEnvelope,
  faExclamationTriangle,
  faFileInvoice,
  faPhoneLaptop,
  faShield,
  faShieldCheck,
  faSpinner,
  faUserClock,
  faUsers,
  faVideoSlash,
  faFolderBlank,
  faLock,
  faPlay
);
